/* AMNAIC theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var f = window.AMNAIC && window.AMNAIC.moneyFormat ? window.AMNAIC.moneyFormat : '${{amount}}';
    var amt = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/g, amt)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
  };

  /* ---------------------------------------------------------- Mobile nav -- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-burger]');
    if (b) {
      var hdr = b.closest('.hdr');
      if (hdr) {
        var open = hdr.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    var s = e.target.closest('[data-search-toggle]');
    if (s) {
      var bar = $('[data-searchbar]');
      if (bar) {
        bar.classList.toggle('is-open');
        var inp = $('input[type=search]', bar);
        if (bar.classList.contains('is-open') && inp) inp.focus();
      }
      return;
    }
    /* Mobile: first tap on a parent link opens its submenu */
    var nl = e.target.closest('.nav__link[data-has-drop]');
    if (nl && window.matchMedia('(max-width:1000px)').matches) {
      var item = nl.closest('.nav__item');
      var drop = item && $('.nav__drop', item);
      if (drop && !item.classList.contains('is-open')) {
        e.preventDefault();
        item.classList.add('is-open');
      }
    }
  });

  /* ---------------------------------------------------------- Accordion --- */
  $$('[data-acc]').forEach(function (root) {
    $$('.acc__btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
  });

  /* ---------------------------------------------------------- Slideshow --- */
  $$('[data-slides]').forEach(function (root) {
    var track = $('.slides__track', root);
    var slides = $$('.slides__slide', root);
    if (slides.length < 2) return;
    var dots = $$('.slides__dot', root);
    var i = 0, timer = null;
    var speed = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      track.style.transition = 'transform .55s cubic-bezier(.2,.7,.3,1)';
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function play() { if (speed > 0) { stop(); timer = setInterval(function () { go(i + 1); }, speed); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    $$('[data-slide-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); play(); }); });
    $$('[data-slide-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); play(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; play();
    });

    go(0);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  });

  /* ------------------------------------------------------------- Gallery -- */
  $$('[data-gallery]').forEach(function (root) {
    var main = $('[data-gallery-main]', root);
    if (!main) return;
    $$('[data-gallery-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var srcset = t.getAttribute('data-srcset');
        var alt = t.getAttribute('data-alt') || '';
        if (src) { main.src = src; main.alt = alt; }
        if (srcset) main.srcset = srcset;
        $$('[data-gallery-thumb]', root).forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ------------------------------------------------------------ Quantity -- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var box = b.closest('.qty');
    var inp = box && $('input', box);
    if (!inp) return;
    var v = parseInt(inp.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    inp.value = v;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ Variant picker -- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = document.getElementById(form.getAttribute('data-variants'));
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idField = $('[name="id"]', form);
    var btn = $('[data-add]', form);
    var priceEl = $('[data-price]', form.closest('[data-product-root]') || document);
    var stockEl = $('[data-stock]', form.closest('[data-product-root]') || document);
    var skuEl = $('[data-sku]', form.closest('[data-product-root]') || document);

    function current() {
      var chosen = $$('[data-opt]', form).map(function (g) {
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
      if (chosen.indexOf(null) !== -1) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function apply() {
      var v = current();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (skuEl) skuEl.textContent = v.sku ? 'SKU ' + v.sku : '';
      if (stockEl) {
        stockEl.textContent = v.available ? 'In stock' : 'Out of stock';
        stockEl.classList.toggle('stock--out', !v.available);
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
      if (history.replaceState && v.id) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    form.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) apply(); });
    apply();
  });

  /* --------------------------------------------------------------- Cart --- */
  $$('[data-cart-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var line = inp.getAttribute('data-line');
      var q = Math.max(0, parseInt(inp.value, 10) || 0);
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: q })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ------------------------------------------------- Rich-text overflow --- */
  /* Merchant-entered spec tables are the main cause of horizontal overflow on
     phones. Wrap each one in its own scroll box so the page itself never grows
     wider than the viewport. CSS handles the no-JS fallback.                 */
  $$('.rte table').forEach(function (tbl) {
    if (tbl.parentNode && tbl.parentNode.classList.contains('tbl-scroll')) return;
    var box = document.createElement('div');
    box.className = 'tbl-scroll';
    box.setAttribute('role', 'region');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', 'Specification table, scrollable');
    tbl.parentNode.insertBefore(box, tbl);
    box.appendChild(tbl);
  });

  /* ------------------------------------------------------------- Reveal --- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('is-in'); });
  }

})();
